import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { setUser } from '../actions'
import { withRouter } from 'react-router-dom'
import { omit } from 'lodash'
import { FormattedMessage, FormattedDate, injectIntl, intlShape } from 'react-intl';

import { callApi } from '../services/fetchService'
import { getSelectOptions } from '../services/selectService'

import FaIcon from '../components/FaIcon'
import Badge from '../components/Badge'
import { Row, Col, Card, Form, Input, Button, Divider, Switch, Select, Spin, List, message } from 'antd'
const FormItem = Form.Item



/**
 * Profile form inside the view
 */

class _ChangePasswordForm extends Component {

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        intl: intlShape.isRequired
    }

    confirmDirty = false
    
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                this.props.onSubmit(omit(values, ['confirmPassword']))
            }
        })
    }

    handleConfirmBlur = (e) => {
        this.confirmDirty = this.confirmDirty || !!e.target.value
    }

    checkConfirm = (rule, value, callback) => {
        const form = this.props.form
        if (value && this.confirmDirty) {
            form.validateFields(['confirmPassword'], { force: true })
        }
        callback()
    }

    checkPassword = (rule, value, callback) => {
        const form = this.props.form;
        if (value && value !== form.getFieldValue('newPassword')) {
            callback(this.props.intl.formatMessage({id: 'profile.passwordDoNotMatch'}))
        } else {
            callback()
        }
    }

    render() {
        const { getFieldDecorator } = this.props.form
        const { intl } = this.props

        const formItemLayout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 18 },
            style: { marginBottom: '10px' }
        }
        const tailFormItemLayout = {
            wrapperCol: { offset: 6, span: 18 }
        }
        
        return (
            <Form layout="horizontal" onSubmit={this.handleSubmit}>
                <FormItem label={<FormattedMessage id="profile.oldPassword" />} {...formItemLayout}>
                    {getFieldDecorator('oldPassword', {
                        rules: [
                            {required: true, message: intl.formatMessage({id: 'profile.oldPasswordRequired'})}
                        ]
                    })(<Input addonBefore={<FaIcon icon="lock" fixedWidth />} type="password" />)}
                </FormItem>
                <FormItem label={<FormattedMessage id="profile.newPassword" />} {...formItemLayout}>
                    {getFieldDecorator('newPassword', {
                        rules: [
                            {required: true, message: intl.formatMessage({id: 'profile.newPasswordRequired'})},
                            {validator: this.checkConfirm}
                        ]
                    })(<Input addonBefore={<FaIcon icon="lock" fixedWidth />} type="password" />)}
                </FormItem>
                <FormItem label={<FormattedMessage id="profile.confirmPassword" />} {...formItemLayout}>
                    {getFieldDecorator('confirmPassword', {
                        rules: [
                            {required: true, message: intl.formatMessage({id: 'profile.confirmPasswordRequired'})},
                            {validator: this.checkPassword}
                        ]
                    })(<Input addonBefore={<FaIcon icon="lock" fixedWidth />} onBlur={this.handleConfirmBlur} type="password" />)}
                </FormItem>
                <Divider />
                <FormItem {...tailFormItemLayout}>
                    <Button type="primary" loading={this.props.updating} htmlType="submit"><FormattedMessage id="profile.changePasswordButton" /></Button>
                </FormItem>
            </Form>
        )
    }

}

const ChangePasswordForm = injectIntl(Form.create()(_ChangePasswordForm))



/**
 * Profile form inside the view
 */

class _ProfileForm extends Component {

    static propTypes = {
        user: PropTypes.object.isRequired,
        onSubmit: PropTypes.func.isRequired,
        intl: intlShape.isRequired
    }
    
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                this.props.onSubmit(values);
            }
        })
    }

    render() {
        const { getFieldDecorator } = this.props.form
        const { intl } = this.props

        const formItemLayout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 18 },
            style: { marginBottom: '10px' }
        }
        const tailFormItemLayout = {
            wrapperCol: { offset: 6, span: 18 },
            style: { marginTop: '25px' }
        }
        
        return (
            <Form layout="horizontal" onSubmit={this.handleSubmit}>
                <FormItem label={<FormattedMessage id="profile.firstName" />} {...formItemLayout}>
                    {getFieldDecorator('firstName', {
                        rules: [{required: true, message: intl.formatMessage({id: 'profile.firstNameRequired'})}]
                    })(<Input/>)}
                </FormItem>
                <FormItem label={<FormattedMessage id="profile.lastName" />} {...formItemLayout}>
                    {getFieldDecorator('lastName', {
                        rules: [{required: true, message: intl.formatMessage({id: 'profile.lastNameRequired'})}]
                    })(<Input/>)}
                </FormItem>
                <Divider />
                <FormItem label={<FormattedMessage id="profile.addressStreet" />} {...formItemLayout}>
                    {getFieldDecorator('addressStreet', {
                        rules: [{required: true, message: intl.formatMessage({id: 'profile.addressStreetRequired'})}]
                    })(<Input/>)}
                </FormItem>
                <FormItem label={<FormattedMessage id="profile.addressNumber" />} {...formItemLayout}>
                    {getFieldDecorator('addressNumber', {
                        rules: [{required: true, message: intl.formatMessage({id: 'profile.addressNumberRequired'})}]
                    })(<Input/>)}
                </FormItem>
                <FormItem label={<FormattedMessage id="profile.addressZip" />} {...formItemLayout}>
                    {getFieldDecorator('addressZip', {
                        rules: [{required: true, message: intl.formatMessage({id: 'profile.addressZipRequired'})}]
                    })(<Input/>)}
                </FormItem>
                <FormItem label={<FormattedMessage id="profile.addressCity" />} {...formItemLayout}>
                    {getFieldDecorator('addressCity', {
                        rules: [{required: true, message: intl.formatMessage({id: 'profile.addressCityRequired'})}]
                    })(<Input/>)}
                </FormItem>
                <FormItem label={<FormattedMessage id="profile.addressCountry" />} {...formItemLayout}>
                    {getFieldDecorator('addressCountry', {
                        rules: [{required: true, message: intl.formatMessage({id: 'profile.addressCountryRequired'})}]
                    })(<Select showSearch optionFilterProp="children" filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                        {getSelectOptions('country', this.props.user.addressCountry)}
                    </Select>)}
                </FormItem>
                <Divider />
                <FormItem label={<FormattedMessage id="profile.mobile" />} {...formItemLayout}>
                    {getFieldDecorator('mobile', {
                        rules: [{required: true, message: intl.formatMessage({id: 'profile.mobileRequired'})}]
                    })(<Input addonBefore={<FaIcon icon="mobile" fixedWidth />} />)}
                </FormItem>
                <FormItem label={<FormattedMessage id="profile.phone" />} {...formItemLayout}>
                    {getFieldDecorator('phone', {
                    })(<Input addonBefore={<FaIcon icon="phone" fixedWidth />} />)}
                </FormItem>
                <FormItem label={<FormattedMessage id="profile.fax" />} {...formItemLayout}>
                    {getFieldDecorator('fax', {
                    })(<Input addonBefore={<FaIcon icon="fax" fixedWidth />} />)}
                </FormItem>
                <FormItem label={<FormattedMessage id="profile.email" />} {...formItemLayout}>
                    {getFieldDecorator('email', {
                        rules: [
                            {type: 'email', message: intl.formatMessage({id: 'profile.wrongEmail'})},
                            {required: true, message: intl.formatMessage({id: 'profile.emailRequired'})}
                        ]
                    })(<Input addonBefore={<FaIcon icon="envelope" fixedWidth />} />)}
                </FormItem>
                <Divider />
                <FormItem label={<FormattedMessage id="profile.language" />} {...formItemLayout}>
                    {getFieldDecorator('language', {
                        rules: [{required: true, message: intl.formatMessage({id: 'profile.languageRequired'})}]
                    })(<Select showSearch optionFilterProp="children" filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                        {getSelectOptions('language', this.props.user.language)}
                    </Select>)}
                </FormItem>
                <FormItem label={<FormattedMessage id="profile.showHelp" />} {...formItemLayout}>
                    {getFieldDecorator('showHelp', {
                        valuePropName: 'checked'
                    })(<Switch />)}
                </FormItem>
                <Divider />
                <FormItem label={<FormattedMessage id="profile.password" />} {...formItemLayout} help={<FormattedMessage id="profile.passwordHelp" />}>
                    {getFieldDecorator('password', {
                        rules: [{required: true}]
                    })(<Input addonBefore={<FaIcon icon="lock" fixedWidth />} type="password" />)}
                </FormItem>
                <FormItem {...tailFormItemLayout}>
                    <Button type="primary" loading={this.props.updating} htmlType="submit"><FormattedMessage id="misc.save" /></Button>
                </FormItem>
            </Form>
        )
    }

}

const ProfileForm = injectIntl(Form.create({
    mapPropsToFields(props) {
        return {
            firstName: Form.createFormField({value: props.user.firstName}),
            lastName: Form.createFormField({value: props.user.lastName}),
            addressStreet: Form.createFormField({value: props.user.addressStreet}),
            addressNumber: Form.createFormField({value: props.user.addressNumber}),
            addressZip: Form.createFormField({value: props.user.addressZip}),
            addressCity: Form.createFormField({value: props.user.addressCity}),
            addressCountry: Form.createFormField({value: props.user.addressCountry}),
            mobile: Form.createFormField({value: props.user.mobile}),
            phone: Form.createFormField({value: props.user.phone}),
            fax: Form.createFormField({value: props.user.fax}),
            email: Form.createFormField({value: props.user.email}),
            language: Form.createFormField({value: props.user.language}),
            showHelp: Form.createFormField({value: props.user.showHelp})
        };
    }
})(_ProfileForm))



/**
 * Profile view
 */

class Profile extends Component {

    static propTypes = {
        setUser: PropTypes.func.isRequired,
        intl: intlShape.isRequired
    }
    
    state = {
        user: null,
        loading: false,
        updating: false
    }

    componentDidMount() {
        const { intl } = this.props
        this.setState({ loading: true })
        callApi({
            endpoint: 'user'
        }).then((data) => {
            this.setState({
                user: data,
                loading: false
            })
        }).catch((data) => {
            message.error(intl.formatMessage({id: 'misc.unknownError'}))
            this.setState({ loading: false })
        })
    }

    updateUser = (user) => {
        const { intl, setUser } = this.props
        this.setState({
            user: Object.assign({}, this.state.user, user),
            updating: true
        })
        callApi({
            endpoint: 'user',
            body: user,
            method: 'POST'
        }).then((data) => {
            this.setState({
                user: data,
                updating: false
            })
            setUser(data)
            message.success(this.props.intl.formatMessage({id: "misc.updateSuccess"}))
        }).catch((err) => {
            if (err.status === 401) {
                message.error(intl.formatMessage({id: 'profile.invalidPassword'}))
            } else {
                message.error(intl.formatMessage({id: 'misc.unknownError'}))
            }
            this.setState({ updating: false })
        })
    }

    changePassword = ({ oldPassword, newPassword }) => {
        const { intl } = this.props
        this.setState({ updating: true })
        callApi({
            endpoint: 'user',
            body: { password: oldPassword, newPassword },
            method: 'POST'
        }).then((data) => {
            this.setState({ updating: false })
            message.success(this.props.intl.formatMessage({id: "misc.updateSuccess"}))
        }).catch((err) => {
            if (err.status === 401) {
                message.error(intl.formatMessage({id: 'profile.invalidPassword'}))
            } else {
                message.error(intl.formatMessage({id: 'misc.unknownError'}))
            }
            this.setState({ updating: false })
        })
    }

    render() {
        const { user, loading, updating } = this.state
      
		if (!user || loading) {
			return (
                <div style={{ textAlign: 'center', marginTop: '50px' }}>
                    <Spin size="large" />
                </div>
            )
        }
        
        return (
            <div>
                <h1><FaIcon icon="user" fixedWidth /> <FormattedMessage id="profile.title" /></h1>
                <Row gutter={24}>
                    <Col lg={14}>
                        <Card title={<span><FaIcon icon="info-circle" /><FormattedMessage id="profile.identification" /></span>}>
                            <ProfileForm user={user} onSubmit={this.updateUser} updating={updating} />
                        </Card>
                    </Col>
                    <Col lg={10}>
                        <Card title={<span><FaIcon icon="chart-bar" /><FormattedMessage id="profile.statistics" /></span>}>
                            <List itemLayout="horizontal" className="statistics">
                                <List.Item><FormattedMessage id="profile.numberOfPatients" /><Badge>{user.numberOfPatients}</Badge></List.Item>
                                <List.Item><FormattedMessage id="profile.numberOfConsultations" /><Badge>{user.numberOfConsultations}</Badge></List.Item>
                                <List.Item><FormattedMessage id="profile.numberOfBloodTests" /><Badge>{user.numberOfBloodTests}</Badge></List.Item>
                                <List.Item><FormattedMessage id="profile.registeredSince" /><Badge><FormattedDate value={user.registrationDate}/></Badge></List.Item>
                                <List.Item><FormattedMessage id="profile.lastConsultation" /><Badge>{user.lastConsultation ? <FormattedDate value={user.lastConsultation}/> : '-'}</Badge></List.Item>
                            </List>
                        </Card>
                    </Col>
                    <Col lg={14}>
                        <Card title={<span><FaIcon icon="lock" /><FormattedMessage id="profile.changePassword" /></span>}>
                            <ChangePasswordForm onSubmit={this.changePassword} updating={updating} />
                        </Card>
                    </Col>
                </Row>
            </div>
        )
    }

}

export default injectIntl(withRouter(connect(null, {
    setUser
})(Profile)))


// WEBPACK FOOTER //
// ./src/views/Profile.js